export default __webpack_public_path__ + "static/media/logo138x75black.f668ae3e.png";